module.exports = __webpack_public_path__ + "assets/logo.67b1cacf.svg";